import { StoreAction, XmAction } from 'store/actions';
import { LevelMoveEligibility } from 'store/level-move/models';
import { LevelMoveOrderReview } from './models/order-review';

export function levelMoveEligibilityReducer(state: LevelMoveEligibility, action: XmAction<LevelMoveEligibility>): LevelMoveEligibility {
    if (action.type === StoreAction.GET_LEVEL_MOVE_ELIGIBILITY) {
        return action.payload;
    }

    return state;
}

export function levelMoveOrderReviewReducer(state: LevelMoveOrderReview, action: XmAction<LevelMoveOrderReview>): LevelMoveOrderReview {
    if (action.type === StoreAction.POST_LEVEL_MOVE_ORDER_REVIEW) {
        return action.payload;
    }

    return state;
}
